import { GraphQLCameraFleetFlagRequester } from '@cobliteam/api-lib';
import type { FleetProducts } from '@cobliteam/common-types';
import { useQuery } from '@tanstack/react-query';

const FLEET_FLAG_QUERY_KEY = 'camera-fleet-flag';

const useCameraFleetFlag = () => {
  const graphQLCameraFleetFlagRequester = new GraphQLCameraFleetFlagRequester();

  const getCameraFleetFlag = (enabled = true) => {
    return useQuery<Boolean>({
      queryKey: [FLEET_FLAG_QUERY_KEY],
      queryFn: graphQLCameraFleetFlagRequester.getCameraFleetFlag,
      retry: false,
      enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Number.POSITIVE_INFINITY,
    });
  };

  const getFleetPremiumPackageFlag = (enabled = true) => {
    return useQuery<FleetProducts | undefined, unknown, boolean>({
      queryKey: [FLEET_FLAG_QUERY_KEY, 'FLEET_PRODUCTS_FLAG'],
      queryFn: graphQLCameraFleetFlagRequester.getFleetProducts,
      select: (data: FleetProducts | undefined) => {
        return !!data?.products.some((product) => product.name.toLowerCase() === 'premium');
      },
      retry: false,
      enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Number.POSITIVE_INFINITY,
    });
  };

  const hasCameraProDMSEvents = (enabled = true) => {
    // theres no diference in camera package anymore, so we can always return true for enable pro DMS events
    return true;
  };

  return {
    FLEET_FLAG_QUERY_KEY,
    getCameraFleetFlag,
    getFleetPremiumPackageFlag,
    hasCameraProDMSEvents,
  };
};

export default useCameraFleetFlag;
